/**
 * Resolve fancyBox plugin as async chunk
 */
const fancyResolver = require.ensure([], require => {
  require('@fancyapps/fancybox');
  require('@fancyapps/fancybox/dist/jquery.fancybox.css');
});

/**
 * Return only fancy instance
 */
export const Instance = async () => {
  await fancyResolver;

  return $.fancybox;
};

/**
 * Default export
 *
 * @param selector
 * @param options
 * @return {Promise}
 */
export default async (selector, options = {}) => {
  if (!selector) {
    throw new Error('Selector is empty');
  }

  if (!(selector instanceof jQuery)) {
    selector = $(selector);
  }

  if (!selector.length) {
    return;
  }

  await fancyResolver;

  const defaultOptions = {};

  options = {...defaultOptions, options};

  $(selector).fancybox(options);

  // Switch off hashed module
  $.fancybox.defaults.hash = false;

  return true;
};



// WEBPACK FOOTER //
// ./templates/floor/assets/js/Global/AsyncModules/fancybox.js